import React, { FunctionComponent } from "react";
import classnames from "classnames";

import "./Icon.css";

type IconProps = JSX.IntrinsicElements["i"] & {
  glyph?: IconGlyph;
};
const ICON_PROPS_DEFAULT: IconProps = {};

export const Icon: FunctionComponent<IconProps> = (
  props = ICON_PROPS_DEFAULT
) => {
  const { glyph, className, ...rest } = props;

  if (!glyph) {
    return null;
  }

  const classNames = classnames("mv-icon", `mv-icon__${glyph}`, className);

  return <i className={classNames} {...rest}></i>;
};

export enum IconGlyph {
  COMMENT = "comment",
  CANCEL = "cancel",
  LIST_VIEW = "list-view",
  THUMB_VIEW = "thumb-view",
  DOWNLOAD_1 = "download-1",
  INFO = "info",
  KEY = "key",
  DOCS = "docs",
  QUESTION = "question",
  USER = "user",
  SAVE = "save",
  ARROW_WIDE_DOWN = "arrow-wide-down",
  LEFT_OPEN = "left-open",
  RIGHT_OPEN = "right-open",
  UP_OPEN = "up-open",
  TAG = "tag",
  MESSAGE_1 = "message-1",
  DOWN_ROUND = "down-round",
  LEFT_ROUND = "left-round",
  RIGHT_ROUND = "right-round",
  UP_ROUND = "up-round",
  LIGHTBOX = "lightbox",
  STATICS = "statics",
  GROUP = "group",
  SETTINGS = "settings",
  PROFILE2 = "profile2",
  FOLDER_OPEN = "folder-open",
  MINUS_ROUND = "minus-round",
  PLUS_ROUND = "plus-round",
  PROFILE3 = "profile3",
  PLUS_NODE = "plus-node",
  DOWN_OPEN = "down-open",
  EYE = "eye",
  BELL = "bell",
  PROFILE = "profile",
  PLUS = "plus",
  FILTER = "filter",
  EDIT = "edit",
  UP_OPEN_1 = "up-open-1",
  RIGHT_DIR = "right-dir",
  UP_DIR = "up-dir",
  LEFT_DIR = "left-dir",
  DOWN_DIR = "down-dir",
  LOCK = "lock",
  FOLDER_CLOSE = "folder-close",
  STATUS = "status",
  CHECK1 = "check1",
  SEARCH = "search",
  POWER = "power",
  DOT_SQUARE = "dot-square",
  ARROW_UP = "arrow-up",
  MENU = "menu",
  MINUS_NODE = "minus-node",
  SHARE = "share",
  STAR = "star",
  CLOCK = "clock",
  LINK = "link",
  CROSS = "cross",
  PLUS_1 = "plus-1",
  PLUS_2 = "plus-2",
  DESCRIPTION = "description",
  MULTISELECT = "multiselect",
  INFO2 = "info2",
  MESSAGE = "message",
  IMPORT = "import",
  CHECK = "check",
  SOLID_PLAY = "solid-play",
  CALENDAR = "calendar",
  ARROW = "arrow",
  VERSION = "version",
  CROSS1 = "cross1",
  BACK = "back",
  FORWARD = "forward",
  PLAY = "play",
  RESHUFFLE = "reshuffle",
  SLIDER_1 = "slider-1",
  VOLUME = "volume",
  STOP = "stop",
  WARNING = "warning",
  DOWNLOAD = "download",
  UPLOAD = "upload",
  CHECKIN = "checkin",
  CHECKOUT = "checkout",
  MINUS = "minus",
  MINUS_1 = "minus-1",
  MINUS_2 = "minus-2",
  RADIO_UNCHECKED = "radio-unchecked",
  RADIO_CHECKED = "radio-checked",
  SLIDE_VIEW = "slide-view",
  FULLSCREEN = "fullscreen",
  FULLSCREEN_EXIT = "fullscreen_exit",
  RESIZE_FULL = "resize-full",
  RESIZE_SMALL = "resize-small",
  GRID = "grid",
  PIN = "pin",
  SPIN3 = "spin3",
  DOCUMENT_FULL_WIDTH = "document-full-width",
  DOCUMENT = "document",
  CROP = "crop",
  SLACK = "slack",
  ANGLE_RIGHT = "angle-right",
  ANGLE_LEFT = 'angle-left',
  ANGLE_DOWN = "angle-down",
  EQUALIZER = "equalizer",
  SLIDERS = "sliders",
  PARAMS = "params",
  SEARCH_TAB_ICON = "search-tab-icon",
  CHECK2 = "check2",
  PLUS_SIGN_GENERIC = "plus-sign-generic",
  COPY = "copy",
}
